module.exports = __webpack_public_path__ + "static/media/purpleLink.3e8d2a05.svg";